// eslint-disable-next-line n/no-deprecated-api
import { isNumber } from 'util'

import { ConfigInterface } from '../Interfaces/ConfigsInterface'
import { DocumentType, DocumentTypes } from '../Interfaces/Draft/DraftInterface'
import { InvoiceTypeInterface } from '../Interfaces/InvoiceTypeInterface'

export const invoiceTypesReplacementMap = {
  SALES_EU_SERVICES: 'SALES_EU_GOODS',
  SALES_NONEU_SERVICES: 'SALES_NONEU_GOODS',
}

export function getInvoiceTypes(
  config: ConfigInterface,
  country: string,
  docType: DocumentType,
  shouldAddInvoiceTypeReplacementMapToExcludedTypes: boolean = true,
): InvoiceTypeInterface[] {
  if (!config) {
    return []
  }
  const excludedTypes = [
    'SALES_CASH_RECEIPT',
    ...(docType === DocumentTypes.ESTIMATE ? [] : ['SALES_OFFER']),
    ...(shouldAddInvoiceTypeReplacementMapToExcludedTypes ? Object.keys(invoiceTypesReplacementMap) : []),
  ]

  const result = Object.keys(config.invoiceTypes)
    .map((key) => config.invoiceTypes[key])
    .filter((t) => !excludedTypes.includes(t.type) && (!t.countryCode || t.countryCode === country))

  return result
}

export function defaultTypeForDocument(document: DocumentType) {
  switch (document) {
    case 'invoice':
      return 'SALES'
    case 'estimate':
      return 'SALES_OFFER'
  }
}

export function getInvoiceType(type: string, config: ConfigInterface, country: string): InvoiceTypeInterface {
  let types = []
  if (config) {
    Object.keys(config.invoiceTypes).map((key) => {
      types.push(config.invoiceTypes[key])
    })
    types = types.filter((t) => {
      return (t.countryCode === country || !t.countryCode) && type == t.type
    })
  }
  return types[0]
}

export function getCurrencies(config: ConfigInterface): any[] {
  if (config) {
    return Object.keys(config.currencies)
      .map((key) => config.currencies[key])
      .filter((c) => c.active === true)
  } else {
    return []
  }
}

export function getCurrencySymbol(config: ConfigInterface, currency?: string | number): string {
  let result = ''
  if (config && currency) {
    const currencies = getCurrencies(config)
    const selected = currencies.find((c) => (isNumber(currency) ? c.id === currency : c.shortName === currency))
    result = selected.symbol ? selected.symbol : selected.shortName
  }
  return result
}

export function getLocales(config: ConfigInterface, country: string): string[] {
  if (!config) {
    return []
  }

  const locales = {}
  for (const locale in config.invoiceTranslations) {
    const a = locale.split('_')

    if (!locales[a[0]]) {
      locales[a[0]] = { locale, priority: 0 }
    }

    const loc = locales[a[0]]
    if (loc.priority < 2) {
      if (a[0] === a[1].toLowerCase()) {
        locales[a[0]] = { locale, priority: 1 }
      }
    }

    // Special cases here
    // Sweden is sv_SE
    if (loc.priority < 3) {
      if (locale === 'sv_SE') {
        locales[a[0]] = { locale, priority: 2 }
      }
    }

    // Default english should be en_GB not en_AU
    if (loc.priority < 3) {
      if (locale === 'en_GB') {
        locales[a[0]] = { locale, priority: 2 }
      }
    }

    if (a[1] === country) {
      locales[a[0]] = { locale, priority: 3 }
    }
  }

  const localeArray = []
  for (const language in locales) {
    localeArray.push(locales[language].locale)
  }

  return localeArray
}

export function getLocale(config: ConfigInterface, lang: string, country: string) {
  const locales = getLocales(config, country)
  return locales.filter((loc) => {
    return loc.indexOf(lang) >= 0
  })[0]
}
